import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Chip } from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { UserReport } from "api/types";
import { useState } from "react";

export interface AssignmentDetailProgressTabProps {
	report: UserReport[];
}

export const AssignmentDetailProgressTab = (
	props: AssignmentDetailProgressTabProps,
): JSX.Element => {
	const { report } = props;
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const getProgress = (reportItem: UserReport): string => {
		let startedCount = 0;
		const totalActivity = reportItem.progress.length;
		if (totalActivity > 0) {
			reportItem.progress.forEach((elem) => {
				if (elem) {
					startedCount++;
				}
			});
		}
		return `${startedCount}/${totalActivity} activities completed`;
	};

	const handleChangePage = (
		event: React.MouseEvent<HTMLButtonElement> | null,
		newPage: number,
	): void => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (
		event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
	): void => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	return (
		<>
			<TableContainer component={Paper}>
				<Table aria-label="simple table" size="medium">
					<TableHead>
						<TableRow>
							<TableCell>First name</TableCell>
							<TableCell align="left">Last name</TableCell>
							<TableCell align="left">Email</TableCell>
							<TableCell align="left">Status</TableCell>
							<TableCell align="left">Progress</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{report.length > 0 &&
							report
								.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
								.map((row, index) => {
									return (
										<TableRow
											key={index}
											sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
										>
											<TableCell component="th" scope="row">
												{row.firstName}
											</TableCell>
											<TableCell align="left">{row.lastName}</TableCell>
											<TableCell align="left">{row.email}</TableCell>
											<TableCell align="left">
												{row.progress.find((elem) => elem === true) ? (
													<Chip
														data-testid="start-chip"
														size="small"
														icon={<CheckIcon />}
														label="Started"
														color="success"
													/>
												) : (
													<Chip
														data-testid="not-start-chip"
														size="small"
														icon={<CloseIcon />}
														label="No attempts made"
														color="error"
													/>
												)}
											</TableCell>
											<TableCell align="left" data-testid="password">
												{getProgress(row)}
											</TableCell>
										</TableRow>
									);
								})}
					</TableBody>
				</Table>
				<TablePagination
					rowsPerPageOptions={[5, 10, 25]}
					component="div"
					count={report.length}
					rowsPerPage={rowsPerPage}
					page={page}
					onPageChange={handleChangePage}
					onRowsPerPageChange={handleChangeRowsPerPage}
				/>
			</TableContainer>
		</>
	);
};
